module.exports = __webpack_public_path__ + "profile.1ehDGzRa.svg";